import React from "react";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { HeaderTextSearchFilter } from "@site/components/HeaderTextSearchFilter";

type SearchBarExtensionProps = {
  labelClassName?: string;
}

const SearchBarExtension: React.FC<SearchBarExtensionProps> = () => {
  return (
    // HeaderTextSearchFilter (visible on md+ in header, in mobile drawer on smaller screens)
    <div className="w-full">
      <HeaderTextSearchFilter />
    </div>
  );
}

registerExtension("_site.header.logo.after", SearchBarExtension, "SearchBarExtension");
